export enum ListingsSorting {
  MostRecent = '-id',
  LeastRecent = '+id',
  MostExpensive = '-priceEUR',
  LeastExpensive = '+priceEUR',
}

export const DEFAULT_LISTINGS_SORTING = ListingsSorting.MostRecent
